import { AxiosResponse } from 'axios';
import { serverAxios } from 'app/utils/axios';
import { GetSupplierNameResponse } from 'app/models/responses/supplier';

class SupplierHttp {
  private static route = '/';

  public async getSupplierName(name: string): Promise<GetSupplierNameResponse> {
    return serverAxios
      .post(SupplierHttp.route, {
        act: 'checksupplier',
        supplier: name.toLowerCase(),
      })
      .then((response: AxiosResponse<GetSupplierNameResponse>) => response.data);
  }
}

export default SupplierHttp;
